module.exports = __webpack_public_path__ + "static/media/d8ea2cc09853bb7d2f07deb57862587f.d8ea2cc0.webp";